<script>
import { tourFunctions } from '../tour-functions'
import { fly } from 'svelte/transition';

import UA from 'ua-parser-js';
const ua = new UA();
let isMobile = ua.getResult().device['type'] == 'mobile';

import Tooltip from './Tooltip.svelte';
let showingThumbsTooltip = false;
const showThumbsTooltip = () => { showingThumbsTooltip = true; }
const hideThumbsTooltip = () => { showingThumbsTooltip = false; }

let showingPrevTooltip = false;
const showPrevTooltip = () => { showingPrevTooltip = true; }
const hidePrevTooltip = () => { showingPrevTooltip = false; }

let showingNextTooltip = false;
const showNextTooltip = () => { showingNextTooltip = true; }
const hideNextTooltip = () => { showingNextTooltip = false; }

export let title = '';
export let scenes;
export let nextScene = tourFunctions.nextScene;
export let prevScene = tourFunctions.prevScene;
export let hasCategories = false;
export let categoryStyle = 'sidebar'; // select, buttons, sidebar
if(isMobile){ categoryStyle = 'select'; }
let keyboardNavIndex = -1;
let highlightedIndex = null; 

scenes = scenes || [];

let currentSceneName;
function getCurrentSceneName(){
    currentSceneName = window.CC.krpano.get("xml.scene");
    return currentSceneName;
}

function loadScene(scene){
    // not sure if async helps with speed or not.
    (async () => {
        window.CC.krpano.call("loadscene("+scene.name+",null,get(skin_settings.loadscene_flags),get(skin_settings.loadscene_blend));");
    })();

    visible = false;
}

let currentCategory = "";
let categoryInput;
export let categories = []; // categories found in scenes 
let visibleScenes = scenes; // scenes for the current category
console.log('categories', categories);

export let showPrevNext = true;
export let thumbsButtonOpen;
export let thumbsButtonClose;

let thumbsgrid; //bind on .thumbsgrid for scrolling behavior
var thumbs = []; //bind on .thumbs for scrolling behavior
let visible = false; // visibility of thumbs grid

// Fire event every time thumb grid visibility changes
$: if(visible || visible == false){
    dispatchEvent(new CustomEvent('krpano:gridtoggle', {
		detail: { grid: visible }
	}));
}

// Gets categories when scenes[] is set
$: if (scenes && hasCategories && categories.length === 0) {
    categories = getCategories();
}

// Converts title case --> Title Case 
function titleCase(str) {
   let words = str.toLowerCase().split(' ');
   for (let i = 0; i < words.length; i++) {
       words[i] = words[i].charAt(0).toUpperCase() + words[i].substring(1);     
   }
   return words.join(' '); 
}

// Gets categories from scenes[]
function getCategories(){
    const result = [];
    const map = new Map();
    for (const item of scenes) {
        if (item.category && item.category !== "null") {
            if(!map.has(item.category)){
                map.set(item.category, true);
                let title = titleCase( item.category?.replace('_', ' ') );
                result.push({ title: title, name: item.category });
            }
        }
    }
    console.log('result', result);
    return result;
}

function getSceneFromName(name){
    return scenes.find((s)=> s.name === name)   
}

// Sets visibleScenes[] according to current category
function changeCategory(category){
    currentCategory = category;
    if(category){
        visibleScenes = scenes.filter(scene => scene.category === category);
    } else {
        visibleScenes = scenes; // null category used for ALL
    }
    return visibleScenes;
}

function showThumbs(){
    if(scenes.length === 0){
        scenes = window.CC.krpano.get('scene').getArray();
        visibleScenes =  scenes;
    }

    getCurrentSceneName();
    scrollToActiveThumb();
    resetNavIndex();
    visible = true;
}

function toggleThumbs(){
  visible ? visible = false : showThumbs();
}

function sleep(milliseconds) {  
      return new Promise(resolve => setTimeout(resolve, milliseconds));  
}

function getActiveSceneIndex(){
    return visibleScenes.findIndex(scene => scene.name === currentSceneName );
}

function scrollToActiveThumb(){
    let activeSceneIndex = getActiveSceneIndex();
    if(activeSceneIndex !== -1 && thumbs[activeSceneIndex]){
        window.scrollthumb = thumbs[activeSceneIndex];
        thumbs[activeSceneIndex].scrollIntoView();
        console.log(activeSceneIndex)
    }
}

function handleKeydown(e, s, type) {
  console.log(s);
    // Check if pressed key is 'Enter'
    if (e.key === 'Enter' ) {
      e.preventDefault();
      if(type === 'scene'){
        _loadScene(s);
      } else if(type === 'category'){
        changeCategory(s.name);
      }
    }
}


function _loadScene(scene){
    loadScene(scene)
    visible = false;
}

// keyboard shortcuts space opens/closes thumbs
document.addEventListener('keydown', function(event) {
    if(event.keyCode === 32) {
      toggleThumbs();
    }
});

function highlightScene(index) {
    if (keyboardNavIndex >= 0 && keyboardNavIndex < visibleScenes.length) {
        // Reset the previous highlighted thumbnail
        thumbs[keyboardNavIndex].classList.remove('highlight');
    }
    
    keyboardNavIndex = index;
    
    // Highlight the current thumbnail
    thumbs[keyboardNavIndex].classList.add('highlight');
    
    // Scroll the highlighted thumbnail into view
    thumbs[keyboardNavIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
}

// left right up down keys navigate thumbs
// enter key loads scene
function navigateWithKeyboard(event) {
  if(visible) {
    switch (event.keyCode) {
        case 37:  // Left arrow key
        case 38:  // Up arrow key
          if (highlightedIndex > 0) {
            highlightedIndex--;
            scrollToHighlightedThumb();
          }
          break;
        case 39:  // Right arrow key
        case 40:  // Down arrow key
          if (highlightedIndex < visibleScenes.length - 1) {
            highlightedIndex++;
            scrollToHighlightedThumb();
          }
          break;
        case 13:  // Enter key
          if (highlightedIndex !== null) {
            _loadScene(visibleScenes[highlightedIndex]);
          }
          break;
    }
  }
}
function scrollToHighlightedThumb() {
    if (highlightedIndex !== null && thumbs[highlightedIndex]) {
        thumbs[highlightedIndex].scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
}
function resetNavIndex() {
  keyboardNavIndex = getActiveSceneIndex();
  highlightedIndex = getActiveSceneIndex();
}
document.addEventListener('keydown', navigateWithKeyboard);
</script>

<style>
/* Component Colors */
:root {
    --thumbs-grid-text-color: #fff;
    --thumbs-grid-text-bg-color-rgb: 0, 0, 0;
    --thumbs-grid-container-bg-color-rgb: 0, 0, 0;
    --thumbs-grid-bottom-menu-bg-color-rgb: var(--theme-color-rgb);
}

h1.tour-title {
    text-align: center;
    font-family: 'Oswald', sans-serif;
    font-size: 2rem;
}

div.thumbs-container {
        background: rgba(var(--thumbs-grid-container-bg-color-rgb),0.8);
        color: white;
        position: fixed;
        width: 100%;
        max-width: 100%;
        height: 100%;
        z-index: 1000;
        left: 0;
        bottom: -101%;
        display: block;
        transition: all 1000ms;
        visibility: hidden;
}

.thumbs-container.active {
    bottom: 0;
    visibility: visible;
}

.thumbs-container main {
    width: 100%;
    height: 100%;
    height: calc(100% - 165px);
    position: relative;
}

.thumbsgrid {
    height: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
}

::-webkit-scrollbar {
 width: 10px;
}
::-webkit-scrollbar-thumb {
 background: #fff;
}

::-webkit-scrollbar-thumb:hover{
    background: #ddd;
}

.bottom-menu {
  background: rgba(var(--thumbs-grid-bottom-menu-bg-color-rgb), 0.8);
  position: fixed;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  z-index: 1001;
  padding: 0.5rem;
  border-radius: 10px 10px 0 0;
  width: 185px;
}

.bottom-menu:hover {
    background: rgba(var(--thumbs-grid-bottom-menu-bg-color-rgb),1);
    border: 3px solid #fff;
    border-width: 3px 3px 0 3px;
}

.thumbs-button {
  color: #fff;
  font-family: 'Oswald', sans-serif;
  font-weight: 300;
  font-size: 1.5rem;
  white-space: nowrap;
}

.thumbsgrid-view {
  margin: 3rem 0;
  list-style: none;
  margin: 0;
  padding: 0;  
  outline: none;
  border: none;
}

.thumbsgrid-view li {
  color: var(--thumbs-grid-text-color);
  cursor: pointer;
  border: 3px solid transparent;
  border-radius: 10px;
}

.thumbsgrid-view li:hover {
    border: 3px solid #fff;
}

.thumbsgrid-view li.active {
    border: 3px solid #fff;
}

.thumbsgrid-view {
  display: grid;
  grid-gap: 0.5rem;
  grid-template-columns: repeat(auto-fill, minmax(275px, 1fr));
  margin: auto;
  width: 95%;
  margin-bottom: 100px;
}

.thumbsgrid-view figure{
    width: 100%;
    height: 100%;
}

.thumbsgrid-view img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: 225px;
    border-radius: 10px;
}

.thumbsgrid-view figure {
    position: relative;
    padding: 0;
    margin: 0;
}

.thumbsgrid-view figcaption {
    position: absolute;
    bottom: 2px;
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    text-align: center;
}

.thumbsgrid-view figcaption h2 {
    background: rgba(var(--thumbs-grid-text-bg-color-rgb), 0.8);
    
    padding: 8px;
    margin: 0;
    display: inline-block;
    border-radius: 5px;
    text-align: center;
    font-size: 1em;
    font-weight: 500;
    font-family: 'Raleway';
}

.scene-categories {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.scene-categories h2 {
    font-family: 'Oswald', sans-serif;
    font-size: 1.5rem;
    margin: 0;
}

.scene-categories ol {
    list-style: none;
    margin: 0.25rem 0;
    outline: none;
    border: none;
    padding: 0.5em;
    border-radius: 6px;
}

.scene-categories li {
  border: 2px solid #fff;
  display: inline-block;
  padding: 0.25rem 1.25rem;
  margin: 0.15rem;
  cursor: pointer;
  border-radius: 6px;
  font-size: 1.3rem;
  font-family: 'Oswald', sans-serif;
  background: #fff;
  color: #000;
}

.scene-categories li:hover {
    background: #fff;
    color:  var(--theme-color);
    border-color: var(--theme-color);
}

.scene-categories li.active {
    background: #fff;
    color: #000;
    background: rgba(var(--theme-color-rgb), 0.8);
    color: #fff;
    border-color: rgba(var(--theme-color-rgb), 0.8);
}

.scene-categories label {
  font-family: Oswald, serif;
  font-size: 1.5rem;
}

.scene-categories select {
  padding: 10px;
    margin: 10px 0;
    border-radius: 5px;
    border: 2px solid #ffffff;
    font-size: 22px;
    min-width: 25%;
    background: rgba(var(--theme-color-rgb),0.8);        
    color: #ffffff;
    font-family: Oswald, serif;
}

main.has-category-sidebar {
  display: flex;
}

main.has-category-sidebar .thumbsgrid {
  flex: 1;
}

.category-sidebar {
  min-width: 200px;
  overflow-y: scroll;
  padding: 10px;
  margin: 0 0 0 18px;
  font-family: 'Oswald', sans-serif;
}

.category-sidebar a {
  font-family: 'Raleway', sans-serif;
  display: block;
  color: #fff;
  padding: 10px;
  text-decoration: none;
  font-size: 1.15rem;
}

.category-sidebar a:hover {
    background-color: #555;
    text-decoration: underline;
    border-radius: 8px;
}

.category-sidebar ol {
    list-style: none;
    margin: 0;
    padding: 0;
}

.category-sidebar li {
    margin: 6px 0;
    padding: 10px;
    font-family: 'Oswald', sans-serif;
    font-family: 'Raleway', sans-serif;
    cursor: pointer;
    font-size: 1.15rem;
    color: #fff;
    border: 2px solid transparent;
}

.category-sidebar li:hover {
    text-decoration: underline;
    border-radius: 8px;
    border: 2px solid #fff;
}

.category-sidebar li.active {
    background-color: rgba(var(--theme-color-rgb),0.8);
    text-decoration: underline;
    border-radius: 8px;
}

/* Next / Prev */
.prev-button, .next-button, .thumbs-button {
    cursor: pointer;
}

.next-button img {
    transform: scaleX(-1);
}

.bottom-menu {
    display: flex;
}
.bottom-menu div {
    display: flex;
    min-width: 45px;
    min-height: 45px;
    margin: 0 8px;
    justify-content: center;
    align-items: center;

  -webkit-touch-callout: none;
    -webkit-user-select: none;
     -khtml-user-select: none;
       -moz-user-select: none;
        -ms-user-select: none;
            user-select: none;
}

.highlight {
    border: 3px solid #fff !important;
}

@media only screen and (max-width: 600px) {
  .thumbsgrid-view {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));      
  }

  .thumbs-container main {
    height: calc(100% - 176px);
  }

  h1.tour-title {
      font-size: 2rem;
  }

  .thumbsgrid-view figcaption h2 {
      font-size: 12px;
  }

  .thumbs-button {
    font-size: 1.25rem;
  }

  .bottom-menu {
    width: auto;
  }

  .bottom-menu:hover {
    border: none;
  }

}
</style>

<div class="thumbs-container no-select" class:active={visible}>


  <header>
    <!-- Title -->
    <h1 class="tour-title">{@html title}</h1>
    <!-- Categories -->
    {#if hasCategories && categories.length > 0}
    <div class="scene-categories">
      <!-- buttons -->
      {#if categoryStyle === 'buttons'}
        <h2>Select a Category:</h2>
        <ol>
          <li
            class:active={!currentCategory}
            tabindex="0"
            on:click={()=> {changeCategory()}}
            on:keydown={(e)=> {handleKeydown(e, {name: ''}, 'category')}}
          >All</li>
          {#each categories as c}
          <li 
            class:active={currentCategory === c.name} 
            tabindex="0" 
            on:click={()=> changeCategory(c.name)}
            on:keydown={(e)=> {handleKeydown(e, c, 'category')}}
          >{c.name}
          </li>
          {/each}
        </ol>
      <!-- select -->
      {:else if categoryStyle === 'select'}
        <label for="categorySelect">Select a Category: </label>
        <select id="categorySelect" bind:value={currentCategory} on:change={() => changeCategory(currentCategory)} bind:this={categoryInput}>
            <option value=''>All</option>
            {#each categories as c}
            <option value={c.name}>{c.name}</option>
            {/each}
        </select>
      {/if}
    </div>
    {/if}
    </header>
    
    <main class:has-category-sidebar={hasCategories && categoryStyle === 'sidebar'}>
      {#if hasCategories && categoryStyle === 'sidebar'}
        <nav class="category-sidebar">
          <h2>Select a Category:</h2>
          <ol>
            <li class:active={!currentCategory} tabindex="0" on:click={()=> {changeCategory()}}>All</li>
            {#each categories as c}
            <li class:active={currentCategory === c.name} tabindex="0" on:click={()=> changeCategory(c.name)}>
                {c.name}
            </li>
            {/each}
          </ol>
        </nav>
        {/if}
        <!-- Grid -->
        <div  class="thumbsgrid" bind:this={thumbsgrid}>
            <ol class="thumbsgrid-view">
                <!-- Scenes -->
                {#each visibleScenes as s,i}
                    <li
                      class:highlight={highlightedIndex === i}
                      class:active={currentSceneName === s.name} 
                      tabindex="0"
                      on:keydown={e => handleKeydown(e, s, 'scene')}
                      bind:this={thumbs[i]}>
                        <figure class="thumb" on:click={_loadScene(s)}>
                            <img src="{s.thumburl}" width="150" height="150" alt="{s.title}"/>
                            <figcaption>
                                <h2>{@html tourFunctions.parseContent(s.title)}</h2>
                            </figcaption>
                        </figure>
                    </li>
                {/each}
            </ol>
        </div>
    </main>
</div><!-- /  .thumbs-container -->
<!-- Button -->
<div class="bottom-menu no-select" transition:fly={{y: 300, duration: 500 }}>
    {#if isMobile || showPrevNext}
    <div class="prev-button" on:click={()=>{prevScene(); visible = false; }} on:mouseenter={showPrevTooltip} on:mouseleave={hidePrevTooltip}>
        <Tooltip text={'Previous Location'} showingTooltip={showingPrevTooltip} position={'top'} />
        <img src="./images/direction.png" width="35" height="35" alt="Prev Scene"/>
    </div>
    {/if}
    <div class="thumbs-button" class:active={visible} on:click={toggleThumbs}  on:mouseenter={showThumbsTooltip} on:mouseleave={hideThumbsTooltip}>
        {#if visible}
            {#if !isMobile && thumbsButtonClose}
                <img src="./images/grid_open.png" width="35" height="35" alt style="margin-right: 10px"/>
                {thumbsButtonClose}
            {:else}
                <Tooltip text={"Close Locations"} showingTooltip={showingThumbsTooltip} position={'top'} />
                <img src="./images/grid_open.png" width="35" height="35" alt="Close Locations"/>
            {/if}
        {:else}
            {#if !isMobile && thumbsButtonOpen}
                <img src="./images/grid_closed.png" width="35" height="35" alt style="margin-right: 10px"/>
                {thumbsButtonOpen}
            {:else}
                <Tooltip text={"Open Locations"} showingTooltip={showingThumbsTooltip} position={'top'} />
                <img src="./images/grid_closed.png" width="35" height="35" alt="Open Locations"/>
            {/if}
        {/if}
    </div>
    {#if isMobile || showPrevNext}
    <div class="next-button" on:click={()=>{nextScene(); visible = false; }} on:mouseenter={showNextTooltip} on:mouseleave={hideNextTooltip}>
        <Tooltip text={'Next Location'} showingTooltip={showingNextTooltip} position={'top'} />
        <img src="./images/direction.png" width="35" height="35" alt="Next Scene"/>
    </div>
    {/if}
</div>